import { StoreDTO, UserDTO, UserRoleDTO, UserRoleName } from 'models'
import { AuthPayload, AuthToken } from 'services/api'
// import { noImageAvatar } from '@touche-lts/panel-ui/dist'

const noImageAvatar =
  'https://www.securities-services.societegenerale.com/uploads/tx_bisgbio/default-profile.png'

export class User {
  public static get isAuthenticated (): boolean {
    return window.localStorage.getItem('jwt') !== null
  }

  public static authenticate (payload: AuthPayload): void {
    const { accessToken, tokenType, userDetails } = payload
    window.localStorage.setItem(
      'jwt',
      JSON.stringify({ accessToken, tokenType })
    )
    this.setUserDetails(userDetails)
  }

  private static setUserDetails (userDetails: UserDTO): void {
    window.localStorage.setItem('userDetails', JSON.stringify(userDetails))
  }

  public static deauthenticate (): void {
    window.localStorage.clear()
  }

  public static get token (): AuthToken {
    const jwt = window.localStorage.getItem('jwt')
    return jwt ? JSON.parse(jwt) : {}
  }

  private static get details (): UserDTO {
    const userJson = window.localStorage.getItem('userDetails')
    if (userJson) {
      return JSON.parse(userJson)
    }

    return {} as UserDTO
  }

  public static get id (): number {
    const { id } = this.details
    return id || null
  }

  public static get roles (): UserRoleDTO[] {
    const { roles } = this.details
    return roles || []
  }

  // static getOrganizations (): OrganizationDTO[] {
  //   const { organizations } = this.getDetails()
  //   return organizations || []
  // }

  public static get imageUrl (): string {
    const { imageUrl } = this.details
    return imageUrl || noImageAvatar
  }

  public static get fullName (): string {
    const { firstName, lastName } = this.details
    return `${firstName || ''} ${lastName || ''}`
  }

  public static get emailAddress (): string {
    const { emailAddress } = this.details
    return emailAddress
  }

  // static get organization (): OrganizationDTO {
  //   const organizations = this.getOrganizations()
  //   if (!organizations || !organizations.length) return null

  //   return organizations[0]
  // }

  public static get userRoleNames (): UserRoleName[] {
    return this.roles.map(({ name }) => name)
  }

  public static get isUserViewerOnly (): boolean {
    return (
      this.userRoleNames.length === 1 &&
      this.userRoleNames[0] === UserRoleName.VIEWER
    )
  }

  public static get roleName (): UserRoleName | null {
    const { role } = this.details
    return (role?.name as UserRoleName) ?? null
  }
 
  public static get isStoreAdmin (): boolean {
    return this.roleName === UserRoleName.STORE_ADMIN
  }
 
  public static get isSuperAdmin (): boolean {
    return this.roleName === UserRoleName.SUPER_ADMIN
  }
 
  public static hasRole (role: UserRoleName): boolean {
    return this.roleName === role
  }

  // ASSIGNED STORES
  public static setAssignedStores (stores: StoreDTO[]): void {
    window.localStorage.setItem('assignedStores', JSON.stringify(stores))
  }

  public static get assignedStores (): StoreDTO[] {
    const storesJson = window.localStorage.getItem('assignedStores')
    if (storesJson) {
      return JSON.parse(storesJson)
    }
    return []
  }

  public static get hasAssignedStores (): boolean {
    return Boolean(this.assignedStores.length)
  }

  public static get firstAssignedStore (): StoreDTO {
    return this.assignedStores[0] || null
  }
}
